

exports.__esModule = true;
var getPPCRoute = exports.getPPCRoute = function getPPCRoute($logger, _ref) {
    var showCYCOInCAPE = _ref.showCYCOInCAPE,
        hasInstallmentOptions = _ref.hasInstallmentOptions,
        hasThreeMonthInstallment = _ref.hasThreeMonthInstallment,
        isCapeReturnKey = _ref.isCapeReturnKey,
        isInstallmentEligible = _ref.isInstallmentEligible,
        isUserLoggedIn = _ref.isUserLoggedIn,
        merchantCountry = _ref.merchantCountry;

    if (isCapeReturnKey) {
        $logger.info('ppc_return_flow');
        if (merchantCountry === 'DE') {
            return 'checkout.xoDeGuest';
        } else {
            return 'checkout.login';
        }
    } else if (merchantCountry === 'US' || merchantCountry === 'GB' || merchantCountry === 'LU') {
        // Swapping CYCO and UL - adding LU for eBay support
        if (isUserLoggedIn) {
            $logger.info('ppc_second_btn_ul_treatment_loggedin');
            // We're redirect to login because it contains logic to redirect to xo-eConsent if needed (same as 1st button)
            return 'checkout.login';
        } else {
            $logger.info('ppc_second_btn_ul_treatment_not_loggedin');
            if (isInstallmentEligible && hasInstallmentOptions) {
                $logger.info('ppc_second_btn_ul_treatment_has_installments');
                if (showCYCOInCAPE) {
                    $logger.info('ppc_second_btn_cape_cyco_treatment');

                    return {
                        to: 'checkout.redirectToCape',
                        params: {
                            showCapeCyco: true
                        }
                    };
                } else if (hasThreeMonthInstallment) {
                    $logger.info('ppc_second_btn_has_three_month_installment_no_cyco_cape_redirect');
                    return 'checkout.redirectToCape';
                } else {
                    return 'checkout.chooseCreditOffer';
                }
            } else {
                return 'checkout.redirectToCape';
            }
        }
    } else {
        // bypass CYCO if no installments
        if (hasInstallmentOptions && (merchantCountry === 'US' && isInstallmentEligible || merchantCountry !== 'US')) {
            // eslint-disable-line
            if (showCYCOInCAPE) {
                $logger.info('ppc_second_btn_cape_cyco_treatment');
                return {
                    to: 'checkout.redirectToCape',
                    params: { showCapeCyco: true }
                };
            }
            $logger.info('ppc_second_btn_cyco');
            return 'checkout.chooseCreditOffer';
        } else if (merchantCountry === 'DE') {
            return {
                to: 'checkout.genericError',
                params: {
                    code: 'BLOCK_PPC_INELIGIBLE_USER'
                }
            };
        } else {
            $logger.info('ppc_second_btn_no_installments');
            return 'checkout.login';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./pages/xo-landing/ppcRoute.js
// module id = ./pages/xo-landing/ppcRoute.js
// module chunks = 0